import {
    IonAvatar, IonItem, IonLabel, IonList, IonListHeader, IonSkeletonText, IonThumbnail
} from '@ionic/react';
import './Skeleton.css';


export const Skeleton = () => {

    return (
        <div className={'skeleton-page-root'}>
            <div className="map-skeleton">
                <IonSkeletonText animated />
            </div>

            <IonList>
                <IonListHeader>
                    <IonLabel>
                        <IonSkeletonText animated style={{ width: '20%' }} />
                    </IonLabel>
                </IonListHeader>
                <IonItem>
                    <IonAvatar slot="start">
                        <IonSkeletonText animated />
                    </IonAvatar>
                    <IonLabel>
                        <h3>
                            <IonSkeletonText animated style={{ width: '50%' }} />
                        </h3>
                        <p>
                            <IonSkeletonText animated style={{ width: '80%' }} />
                        </p>
                        <p>
                            <IonSkeletonText animated style={{ width: '60%' }} />
                        </p>
                    </IonLabel>
                </IonItem>
                <IonItem>
                    <IonThumbnail slot="start">
                        <IonSkeletonText animated />
                    </IonThumbnail>
                    <IonLabel>
                        <h3>
                            <IonSkeletonText animated style={{ width: '50%' }} />
                        </h3>
                        <p>
                            <IonSkeletonText animated style={{ width: '80%' }} />
                        </p>
                        <p>
                            <IonSkeletonText animated style={{ width: '60%' }} />
                        </p>
                    </IonLabel>
                </IonItem>
                <IonItem>
                    <IonSkeletonText animated style={{ width: '27px', height: '27px' }} slot="start" />
                    <IonLabel>
                        <h3>
                            <IonSkeletonText animated style={{ width: '50%' }} />
                        </h3>
                        <p>
                            <IonSkeletonText animated style={{ width: '80%' }} />
                        </p>
                        <p>
                            <IonSkeletonText animated style={{ width: '60%' }} />
                        </p>
                    </IonLabel>
                </IonItem>
            </IonList>
        </div>
    );
};